module.exports = __webpack_public_path__ + "images/sgp/featuredContentImages/mediumSizeRelatedContentImage1.webp";